import React, {
  useState,
  useEffect,
  useMemo,
  useLayoutEffect,
  useCallback,
} from "react";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Drawer, Affix, Modal, message } from "antd";
import { useStores } from "@/store";
import { getQuery } from "@/service/http";
import qs from "qs";
import { Button, Header, WriteReview, Redeem } from "@/components";
import firebaseTrack from "@/service/firebase";
import { useObserver } from "mobx-react-lite";
import {
  Banner,
  Profile,
  Reviews,
  Aside,
  Menus,
  Details,
  Grid,
} from "./components";
import "./index.less";

const BASE_URL =
  process.env.REACT_APP_MODE === "PRODUTION"
    ? "https://book.diningcity.asia"
    : "https://staging-book.diningcity.asia";

/**
 * 餐厅详情
 * PC和移动端使用不同的布局方式
 */
const Main = () => {
  const { t } = useTranslation();
  const { restaurantStore, reviewStore } = useStores();
  const { id } = useParams();
  const location = useLocation();
  const [restaurant, setRestaurant] = useState(null);
  const [chef, setChef] = useState(null);
  const [menus, setMenus] = useState([]);
  const [partners, setPartners] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [visible, setVisible] = useState(false);
  const [currentDate, setCurrentDate] = useState({});
  const [capacity, setCapacity] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [photosParams, setPhotosParams] = useState({
    page: 1,
    per_page: 10,
    total_pages: 1,
    total_count: 0,
  });

  const [reviewVisible, setReviewVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState({
    visible: false,
    tip: "",
  });
  const [currentReview, setCurrentReview] = useState(null);
  const {
    lang,
    project,
    accent_color,
    private_token,
    login_url,
    source,
    access_code,
    access_password,
    callback,
    payment,
    reserve,
  } = getQuery();
  const weburl = useMemo(() => {
    if (!restaurant) return "";
    const { id } = restaurant;
    let path = `${BASE_URL}/#/restaurants/${id}/reservation`;
    const query = {
      lang,
      project,
      source,
      access_code,
      access_password,
      private_token,
      date: currentDate.date,
      time: currentDate.formated_time,
      top: callback,
      hideBack: true,
    };
    if (payment) {
      path += "/complete";
      const [reservation_code, reservation_id] = payment.split("___");
      query.reservation_code = reservation_code;
      query.reservation_id = reservation_id;
      setTimeout(() => {
        setVisible(true);
      }, 500);
    }
    return path + "?" + qs.stringify(query);
  }, [restaurant, currentDate]);
  const showMenu = useMemo(() => {
    return menus.length || chef;
  }, [menus, chef]);
  const showRedeem = useMemo(() => {
    return restaurant && restaurant.reservation_type == 4;
  }, [restaurant]);
  const capacityText = useMemo(() => {
    if (!capacity) return "";
    const { capacity_desc_humanize, capacity_desc } = capacity;
    if (!capacity_desc_humanize) return "";
    if (capacity_desc_humanize === "Full" && capacity_desc === "no") {
      return t("FULL_BOOKED");
    }
    if (capacity_desc_humanize === "Few seats left") {
      return t("WEB.Book now");
    }
    return capacity_desc_humanize;
  }, [capacity]);

  /** 分片加载全部数据 */
  const handleNextPhotts = useCallback(async () => {
    console.log(photos.length, photosParams.total_count);
    let requestId;
    if (photosParams.page <= photosParams.total_pages) {
      const data = await restaurantStore.getPictures(photosParams);
      const { data: photos } = data;
      if (photosParams.page === 1) {
        setPhotos(photos);
      } else {
        setPhotos((pre) => [...pre, ...photos]);
      }
      setPhotosParams((pre) =>
        Object.assign(pre, { page: photosParams.page + 1 })
      );
      requestId = window.requestAnimationFrame(handleNextPhotts);
    } else {
      requestId && window.cancelAnimationFrame(requestId);
    }
  }, [photos, photosParams]);
  useEffect(() => {
    restaurantStore.setUrl(id);
    restaurantStore.getRestaurantDetails().then((data) => {
      setRestaurant(data);
      firebaseTrack({
        firebase_screen: "Event venue details",
        id: data.id,
        project,
      });
      Promise.all([
        restaurantStore.getPartners(data.region.key_word),
        restaurantStore.getCapacity(),
        restaurantStore.getPictures(photosParams),
        restaurantStore.getChef(),
        restaurantStore.getMenus(),
      ]).then(([a, b, c, d, e]) => {
        const {
          data: photos,
          pagination: { total_count, total_pages, current_page },
        } = c;
        setPartners(a);
        setCapacity(b);
        setPhotos(photos);
        setPhotosParams((pre) =>
          Object.assign({}, pre, {
            total_count,
            total_pages,
            page: current_page + 1,
          })
        );
        setChef(d);
        setMenus(e);
        setLoaded(true);
      });
    });
  }, [id, location]);

  useEffect(() => {
    if (restaurant) {
      // auto booking
      if (reserve === "true") {
        onBook({});
      }
    }
  }, [restaurant]);

  useLayoutEffect(() => {
    if (loaded) {
      setTimeout(() => {
        restaurantStore.setHeight();
      }, 500);
    }
  }, [loaded]);

  /**选择预定时间 */
  function onBook(item) {
    firebaseTrack({ project, id: restaurant.id }, "tap_book_now");
    if (private_token) {
      setCurrentDate(item);
      setVisible(true);
    } else {
      window.top.location.href = login_url;
    }
  }
  /**跳转页面 */
  function redirect(link) {
    if (link) {
      window.open(link, "_blank");
    }
  }
  // banner 埋点
  function favoriteTrack() {
    firebaseTrack({ project }, "tap_add_to_collection");
  }
  // menu 埋点
  function dishTrack(sub) {
    firebaseTrack({ project, id: sub.id }, "tap_dish_details");
  }
  // 打开评论窗口, 如果没有token信息，则跳转登录
  const openReviewPanel = () => {
    if (window.private_token) {
      return setReviewVisible(true);
    }
    window.top.location.href = login_url;
  };
  // 新增评论
  const onSubmitReview = (type, rid, options) => {
    reviewStore.submitReview(type, rid, options).then((res) => {
      if (res && res.status) {
        setSuccessVisible({
          visible: true,
          tip: res.message
            .split("\n")
            .map((item) => `<p>${item}</p>`)
            .join(""),
        });
        setRestaurant({
          ...restaurant,
          reviews_count: restaurant.reviews_count + 1,
        });
        message.success(t("REVIEW.Saved Successfully"));
        reviewStore.reviewInit();
        reviewStore.deleteDraft(restaurant.id);
        setReviewVisible(false);
      }
    });
  };

  return (
    <div className="page-restaurant">
      <div className="page-restaurant--left" hidden={partners.length === 0}>
        <Affix>
          {partners.map((group, index) => {
            return (
              <div className="page-restaurant--partner" key={index}>
                <div
                  className="partner-title"
                  style={{
                    backgroundColor: accent_color,
                  }}
                >
                  {group.name ? group.name : t("WEB.Partners")}
                </div>
                {group.sponsors.slice(0, 5).map((item, index2) => {
                  return (
                    <a
                      className="partner-item"
                      onClick={() => redirect(item.link)}
                      key={index2}
                    >
                      <img src={item.image_url} alt="" />
                    </a>
                  );
                })}
              </div>
            );
          })}
        </Affix>
      </div>
      <section className="page-restaurant--main">
        {restaurant ? (
          <React.Fragment>
            <Banner
              photos={photos}
              restaurant={restaurant}
              cover={restaurant.cover}
              track={favoriteTrack}
              post={
                <div onClick={openReviewPanel}>
                  <i className="icon icon-review-circle"></i>
                </div>
              }
            />
            <Grid
              restaurant={restaurant}
              loadMore={handleNextPhotts}
              photos={photos}
              partners={partners}
              track={favoriteTrack}
              post={
                <div onClick={openReviewPanel}>
                  <i className="icon icon-review-circle"></i>
                </div>
              }
            />
            <Profile restaurant={restaurant} />
            <Navigate
              menus={menus}
              showMenu={showMenu}
              restaurant={restaurant}
              project={project}
            />
            <Menus menus={menus} chef={chef} track={dishTrack} />
            <Reviews restaurant={restaurant} setRestaurant={setRestaurant} />
            <Details restaurant={restaurant} />
            <footer
              className="page-footer page-footer--booking"
              align="right"
              hidden={
                (!restaurant.booking_enabled && !capacityText) || showRedeem
              }
            >
              <Button
                type="primary"
                onClick={() => onBook({})}
                style={{
                  backgroundColor: accent_color,
                }}
              >
                {capacityText}
              </Button>
            </footer>
            <footer
              className="page-footer not-hidden page-footer--redeem"
              align="right"
            >
              {showRedeem && <Redeem restaurant={restaurant} />}
            </footer>
          </React.Fragment>
        ) : null}

        <Drawer
          className="restaurant-drawer"
          placement="right"
          closable={false}
          onClose={() => setVisible(false)}
          visible={visible}
        >
          <Header title={t("WEB.Book now")} onClick={() => setVisible(false)} />
          <Aside weburl={weburl} />
        </Drawer>

        <WriteReview
          visible={reviewVisible}
          restaurant={restaurant}
          editReview={currentReview}
          successVisible={successVisible}
          setSuccessVisible={setSuccessVisible}
          setVisible={setReviewVisible}
          onSubmitReview={onSubmitReview}
        />
      </section>
    </div>
  );
};

/* 中部导航栏 */
const Navigate = ({ menus, showMenu, restaurant, project }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");
  const [currentMenu, setCurrentMenu] = useState("");
  const [navigates, setNavigates] = useState([]);
  const [affixed, setAffixed] = useState(false);
  const showMenuNavi = useMemo(() => {
    return menus.length > 1 && affixed;
  }, [menus, affixed]);
  useEffect(() => {
    setNavigates(
      [
        showMenu ? { label: t("WEB.Menu"), value: "menu" } : null,
        restaurant.reviews_count
          ? { label: t("WEB.ReviewsTitle"), value: "reviews" }
          : null,
        { label: t("WEB.Details"), value: "details" },
      ].filter((i) => i !== null)
    );
  }, [showMenu]);
  function onChange(affixed) {
    setAffixed(affixed);
    if (!affixed) {
      setCurrentMenu("");
    }
  }
  function scrollToNavi(name) {
    setSelected(name);
    firebaseTrack({ project }, `tap_${name}_tab`);
    scrollTo(`.page-restaurant--${name}`, name === "menu" ? -65 : -40);
  }
  function scrollToMenu(menuId) {
    setCurrentMenu(menuId);
    firebaseTrack({ project, id: menuId }, "tap_meal_tab");
    scrollTo(`#menu-item-${menuId}`, -60);
  }
  function scrollTo(domSelector, offset = 20) {
    try {
      let $el = document.querySelector(domSelector);
      var headerOffset = 35;
      const bodyRect = document.body.getBoundingClientRect().top;
      var elementPosition = $el.getBoundingClientRect().top;
      var offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition - bodyRect + offset,
        behavior: "smooth",
      });
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <Affix onChange={onChange}>
      <div className="page-restaurant--navigate">
        {navigates.map((item, index) => {
          return (
            <span
              key={index}
              data-selected={selected === item.value}
              onClick={() => scrollToNavi(item.value)}
            >
              {item.label}
            </span>
          );
        })}
      </div>
      {/* 移动端，有多个菜单，需要悬浮导航 */}
      <div className="menu-navigate" hidden={!showMenuNavi}>
        {menus.map((item) => {
          return (
            <span
              data-select={item.id == currentMenu}
              key={item.id}
              onClick={() => scrollToMenu(item.id)}
            >
              {item.menu_title}
            </span>
          );
        })}
      </div>
    </Affix>
  );
};

export default Main;
